import LandingPage from './components/landingPage/index';
import './App.css';
import { useState } from 'react';
import SuccessDialog from './components/dialog/endDialog';


function App() {
  const [completed, setCompleted] = useState(false);
  return (
    <div className="App">
      {completed ?
      <SuccessDialog /> :
      <LandingPage setCompleted={setCompleted} /> }
    </div>
  );
}

export default App;